// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1fvdglyw button:not([disabled]):after{border:none}._1e0c1txw{display:flex}\n._u5f3v77o{padding-right:var(--ds-space-025,2px)}", ""]);
// Exports
module.exports = exports;
